import React, { useState } from 'react';

import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { routes } from '@vlabs/shared/navigation/routes';
import { PaginationPanel } from '@vlabs/uikit';
import { useHistory } from 'react-router-dom';

import st from './HandlerListPage.module.sass';
import { HandlerListPageHeader } from './HandlerListPageHeader.tsx';
import {
  useHandlersList,
  useHandlersCount,
  PAGE_SIZE_OPTIONS,
} from './store';
import { HandlerListTableView } from './table-view/index.ts';

export default function HandlerListPage() {
  const history = useHistory();

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  const { data: handlersList } = useHandlersList({ page: pageIndex + 1, page_size: pageSize });
  const { data: handlersCount } = useHandlersCount();

  const onCreateHandlerPage = () => {
    history.push(routes.handlers.create);
  };

  const data = handlersList?.handlers ?? [];
  const count = handlersCount?.handlers_count ?? 0;
  const pageCount = Math.ceil(count / pageSize);

  const changePageSize = (nextPageSize) => {
    setPageIndex(0);
    setPageSize(nextPageSize);
  };

  return (
    <Page className={st.Page}>
      <PageContent>
        <HandlerListPageHeader
          onCreateHandler={onCreateHandlerPage}
        />
        <div className={st.Root}>
          <HandlerListTableView
            data={data}
          />
          <div className={st.Pagination}>
            <PaginationPanel
              canNextPage={pageIndex + 1 < pageCount}
              canPreviousPage={pageIndex > 0}
              gotoPage={setPageIndex}
              nextPage={() => setPageIndex((currentPage) => currentPage + 1)}
              pageCount={pageCount}
              pageIndex={pageIndex}
              pageSize={pageSize}
              pageSizeOptions={PAGE_SIZE_OPTIONS}
              previousPage={() => setPageIndex((currentPage) => currentPage - 1)}
              setPageSize={changePageSize}
            />
          </div>
        </div>
      </PageContent>
    </Page>
  );
}
